
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { PdfActionPlanOptions } from "../types";

/**
 * Add action plan page
 */
export const addActionPlan = (doc: jsPDF, { improvements, pageWidth, colors }: PdfActionPlanOptions): void => {
  // Add a new page for the action plan
  doc.addPage();
  
  // Action plan header - using techne-primaryPurple
  doc.setFillColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.rect(0, 0, pageWidth, 30, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text("Recommended Action Plan", pageWidth / 2, 20, { align: "center" });
  
  // Action plan content
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(14);
  doc.text("Next Steps for Improving AI Governance", 15, 45);
  
  doc.setDrawColor(colors?.purple[0] || 189, colors?.purple[1] || 71, colors?.purple[2] || 230);
  doc.setLineWidth(0.8);
  doc.line(15, 50, pageWidth - 15, 50);
  
  // Create action plan table
  const actionPlanHeaders = [["Priority", "Action Item", "Timeframe", "Expected Impact"]];
  
  // Generate action items based on improvement areas
  const actionItems = [];
  
  if (improvements.length > 0) {
    improvements.forEach((improvement, index) => {
      const priority = index < 2 ? "High" : "Medium";
      const timeframe = index < 2 ? "1-3 months" : "3-6 months";
      const impact = index < 2 ? "Significant" : "Moderate";
      
      actionItems.push([priority, improvement, timeframe, impact]);
    });
  } else {
    // Default actions if no specific improvements identified
    actionItems.push(
      ["High", "Establish an AI governance committee", "1-3 months", "Significant"],
      ["High", "Develop an AI risk assessment framework", "1-3 months", "Significant"],
      ["Medium", "Create an AI ethics policy", "3-6 months", "Moderate"]
    );
  }
  
  autoTable(doc, {
    head: actionPlanHeaders,
    body: actionItems,
    startY: 60,
    theme: 'grid',
    headStyles: {
      fillColor: [colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 250],
    },
    margin: { top: 15, bottom: 15 },
  });
};
